export default __webpack_public_path__ + "static/media/logo-mostaza.7c21267f.svg";